import { useQuery } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { GET_PLANS } from '@/queries/queries';
import { useCurrency } from '@/hooks/use-currency';
import { findCheapestPaidPlanPrice } from '@/lib/billing/findCheapestPaidPlanPrice';

/** "a partir de R$X/mês" for the PRO upgrade dialogs, or null while plans
 *  load / when no paid plan exists. Cache-first: the plans list is small and
 *  effectively static per session. */
export function useUpgradePriceAnchor(): string | null {
  const { t } = useTranslation();
  const { isBRL, formatCurrency } = useCurrency();
  const { data } = useQuery(GET_PLANS, { fetchPolicy: 'cache-first' });
  const price = findCheapestPaidPlanPrice(data?.plans, isBRL);
  if (price === null) return null;
  return t('proDialog.priceAnchor', { price: formatCurrency(price) });
}
